import { Controller, type Control } from "react-hook-form";

import { TraderDetailsProfileField } from "../TraderDetailsProfileField";
import { TraderDetailsProfileSelect } from "../TraderDetailsProfileSelect";
import type { SelectOption, TraderDetailsStepOneFormValues } from "../TraderDetailsStepOne/types";

interface TraderDetailsLanguageFieldProps {
  control: Control<TraderDetailsStepOneFormValues>;
  errorMessage: string;
  isDisabled?: boolean;
  label: string;
  options: SelectOption[];
  placeholder: string;
}

export const TraderDetailsLanguageField = ({
  control,
  errorMessage,
  isDisabled = false,
  label,
  options,
  placeholder,
}: TraderDetailsLanguageFieldProps) => (
  <Controller
    control={control}
    name="language"
    render={({ field }) => (
      <TraderDetailsProfileField
        id="language-select"
        label={label}
        errorMessage={errorMessage}
        required
      >
        <TraderDetailsProfileSelect
          id="language-select"
          value={field.value}
          options={options}
          placeholder={placeholder}
          errorMessage={errorMessage}
          isDisabled={isDisabled}
          onBlur={field.onBlur}
          onChange={field.onChange}
        />
      </TraderDetailsProfileField>
    )}
  />
);
